import { request } from "./http";

export interface FeatureFlag {
  id: string;
  flag_key: string;
  value: boolean;
  rollout_pct: number;
  user_id: string | null;
  note: string | null;
  updated_at: string | null;
}

export interface FlagCreate {
  flag_key: string;
  value?: boolean;
  rollout_pct?: number;
  note?: string | null;
}

export interface WebhookEndpoint {
  id: string;
  url: string;
  event_types: string[];
  enabled: boolean;
  last_status: string | null;
  last_attempt_at: string | null;
  consecutive_failures: number;
  created_at: string | null;
}

export interface WebhookDelivery {
  id: string;
  endpoint_id: string | null;
  event_type: string;
  status: string;
  response_status: number | null;
  attempt_count: number;
  delivered_at: string | null;
  created_at: string | null;
}

export interface CopyTrader {
  id: string;
  user_id: string | null;
  display_name: string;
  public: boolean;
  verified: boolean;
  performance_fee_bps: number;
  created_at: string | null;
}

export interface CopyFollow {
  id: string;
  follower_user_id: string | null;
  leader_trader_id: string | null;
  copy_factor: string;
  max_risk_pct: string | null;
  stopped_at: string | null;
  stop_reason: string | null;
  created_at: string | null;
}

export const featureFlags = {
  list: () => request<FeatureFlag[]>("/api/v1/admin/feature-flags"),
  create: (body: FlagCreate) => request<FeatureFlag>("/api/v1/admin/feature-flags", { body }),
  patch: (id: string, body: Partial<FlagCreate>) =>
    request<FeatureFlag>(`/api/v1/admin/feature-flags/${id}`, { method: "PATCH", body }),
  remove: (id: string) =>
    request<void>(`/api/v1/admin/feature-flags/${id}`, { method: "DELETE" }),
};

export const webhooks = {
  list: () => request<WebhookEndpoint[]>("/api/v1/admin/webhooks"),
  setEnabled: (id: string, enabled: boolean) =>
    request<{ id: string; enabled: boolean }>(`/api/v1/admin/webhooks/${id}`, {
      method: "PATCH",
      body: { enabled },
    }),
  deliveries: () => request<WebhookDelivery[]>("/api/v1/admin/webhooks/deliveries"),
};

export const copyTrading = {
  traders: () => request<CopyTrader[]>("/api/v1/admin/copy/traders"),
  follows: () => request<CopyFollow[]>("/api/v1/admin/copy/follows"),
};
